import React from 'react';
import { all } from '@awesome.me/kit-2cbcf7d4a0/icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Divider } from '@mui/material';
import { useBoolean } from '../../../../../hooks';
import { Accordion, AccordionDetails, AccordionSummary } from '../../expansion-panel';
import './styles.scss';

// And add to the library
library.add({ ...all });

const ExpandableItem = ({ header, children, customKey, detailsClassName, isExpanded }: any) => {
    const expanded = useBoolean(isExpanded);

    return (
        <Accordion
            expanded={expanded.value}
            key={customKey}
            className="expandable-panel"
            slotProps={{ heading: { component: 'div' } }}
        >
            <AccordionSummary className="expand-summary">
                <div
                    className={children ? 'summary-expand-icon' : 'summary-expand-icon disabled'}
                    onClick={() => {
                        if (children) {
                            expanded.setValue(!expanded.value);
                        }
                    }}
                    data-testid="summary-expand-icon"
                >
                    <FontAwesomeIcon
                        icon={['fas', 'chevron-down']}
                        className={`icon-arrow ${expanded.value && children ? 'expanded' : ''}`}
                    />
                </div>
                <div className="header-content">
                    <div className="header">{header}</div>
                    <div className="content-area" />
                </div>
            </AccordionSummary>

            {Boolean(children) && (
                <>
                    <Divider
                        classes={{
                            root: 'list-content-divider',
                        }}
                    />
                    <div className="wrapper">
                        <Divider
                            classes={{
                                root: 'vertical-divider',
                            }}
                            orientation="vertical"
                        />
                        <AccordionDetails className={detailsClassName || 'details-wrapper'}>
                            {children}
                        </AccordionDetails>
                    </div>
                </>
            )}
        </Accordion>
    );
};

export default ExpandableItem;
